import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


// reactstrap components
import {
    Button,
    Container,
    Row,
    Col,
    FormGroup, 
    Modal, 
} from "reactstrap";



const ProcessingModal = (props)=>{
    const {displayModal,handleCloseOfModalWindow} = props;
    
    return(
        <>
            <Modal zIndex={2000} centered isOpen={displayModal} toggle={() => handleCloseOfModalWindow(false)}>
                <div className="text-center p-5">
                        <div className="d-flex justify-content-center align-items-center text-success ">
                            <div>
                                <p className="m-0"> 
                                    <span className="spinner-border spinner-border-sm mb-1 mr-2" role="status" aria-hidden="true"></span> 
                                    <span style={{fontSize:"1.2rem"}}>Processing ... Please wait...</span>
                                </p>
                            </div>
                        </div>
                </div>
            </Modal>
        </>
    );

}
export default ProcessingModal;